export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=66b79c20&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/index.vue?vue&type=template&id=66b79c20&
// module id = 888
// module chunks = 0